(() => {
    class Pagination {
        constructor(Component, container) {
            this.container = container;
            this.Component = Component;
            this.Component.Observer.register(this);
            this.bind();
        }
        get backward()  { return this._backward || (this._backward = this.container.querySelector('.js-slider-pagination-backward'))}
        get forward()   { return this._forward  || (this._forward  = this.container.querySelector('.js-slider-pagination-forward'))}

        setButtonVisibility(arrow, show) {
            arrow.classList.toggle('inactive', !show);
        }
        setBackwardVisibility() {
            this.setButtonVisibility(this.backward, this.isAtEnd());
        }
        setForwardVisibility() {
            this.setButtonVisibility(this.forward, this.isAtStart());
        }
        isNecessary() {
            return this.Component.viewer.width() > this.Component.itemsContainer.width();
        }
        isAtStart() {
            return this.Component.getScrollValue() > 5;
        }
        isAtEnd() {
            return this.Component.getScrollValue() + this.Component.width < this.Component.allItemsWidth - 5;
        }
        bind() {
            this.Component.$
                .on('click', '.js-slider-pagination-backward', () => this.Component.scrollTo(this.Component.activeItem.next(), 1))
                .on('click', '.js-slider-pagination-forward', () => this.Component.scrollTo(this.Component.activeItem.prev(), -1))
            ;
        }
        update() {
            if (this.Component.fitMobileItems) {
                this.Component.container.classList.toggle('no-navigation', this.isNecessary());
                this.Component.container.classList.toggle('at-start', this.isAtStart());
                this.Component.container.classList.toggle('at-end', this.isAtEnd());
                this.setBackwardVisibility();
                this.setForwardVisibility();
            } else {
                this.Component.container.classList.toggle('no-navigation', App.Interface.Utilities.isMobile() ? true : this.isNecessary());
            }
        }
    }

    class Bullets {
        constructor(Component, container) {
            this.Component = Component;
            this.container = $(container);
            this.Component.Observer.register(this);
            this.bind();
        }
        get items()     { return this.container.children('span') }
        // Sets the active bullet by n-th child, aka index starting with 1, not 0.
        setActiveBullet(n) {
            this.items.removeClass('active');
            this.items[n-1].classList.add('active');
        }
        set amount(amount) {
            if (amount) {
                if (amount < 0) {
                    this.items.slice(amount).remove();
                } else {
                    for (let i = 0; i < amount; ++i) {
                        this.container.append('<span class="js-bullet"></span>');
                    }
                }
            }
        }

        // Sets this.pages to an array of page widths. Pages are used for bullets
        // and denote the widths of each set of adjacent items that can be displayed
        // at once. Future-proofed for items of varying widths.
        calculatePages() {
            this.pages = [0];
            const width = this.Component.width;
            // Iterate over all items and add their widths to the page. If there is
            // no more room on the last page, create a new one and continue.
            for(let i = 0; i < this.Component.items.length; ++i) {
                const itemWidth = $(this.Component.items[i]).outerWidth();
                if (this.pages[this.pages.length-1] + itemWidth >= width) {
                    this.pages.push(itemWidth);
                } else {
                    this.pages[this.pages.length-1] += itemWidth;
                }
            }
            if (this.Component.singleColum) {
                this.pages.splice(0, 1);
            }
            this.amount = this.pages.length - this.items.length;
        }

        bind() {
            const Self = this;
            this.container.on('click', 'span', function() {
                const $bullet = $(this);
                const index = $bullet.index();
                let sum = 0;
                for (let i = 0; i < index; ++i) {
                    sum += Self.pages[i];
                }
                Self.Component.scrollTarget.animate({
                    scrollLeft: sum - (Self.Component.width - Self.pages[index]) / 2
                }, Self.Component.scrollingSpeed);
                if (Self.Component.singleColum) {
                    Self.Component.setActiveItem($(Self.Component.items[index]));
                }

                if (Self.Component.autoPlay) {
                    clearInterval(Self.Component.playerTimer);
                    Self.Component.restartAutoPlayer();
                }
            });
        }
        update() {
            this.calculatePages();
            if (!this.container.length) return;
            if (this.Component.getScrollValue() >= this.Component.allItemsWidth - this.Component.width) {
                this.setActiveBullet(this.pages.length);
                return;
            }
            const scrollCenter = this.Component.getScrollValue() + (this.Component.width / 2);
            let sum = 0, i = 0;
            do {
                sum += this.pages[i];
                ++i;
            } while (sum < scrollCenter);
            this.setActiveBullet(i);
            this.Component.setActiveItem($(this.Component.items[i-1]) || $(this.Component.items[i]));
        }
    }

    class Slider extends App.Component {
        constructor(element) {
            super(element);

            // Pagination
            const pagination = this.container.querySelector('.slider-pagination');
            if (pagination) this.Pagination = new Pagination(this, pagination);

            // Bullets
            const bullets = this.container.querySelector('.mm-bullets');
            if (bullets) this.Bullets = new Bullets(this, bullets);

            /* vars */
            this.active = this.activeItem.index() === -1 ? 0 : this.activeItem.index();

            /* Configuration */
            // UX: we don't want an Item to cover the entire width
            this.covering                   = 0.8;
            this.scrollingSpeed             = 200;
            this.centeringTransitionSpeed   = 0;
            // If slider should fix to sides for first and last Item
            this.allowFixation              = true;
            this.autoPlay                   = this.container.classList.contains('js-slider-auto-play');
            this.scrollSnap                 = this.container.classList.contains('js-slider-scroll-snap');
            // If slider fits item to width on mobile view
            this.fitMobileItems             = this.container.classList.contains('js-fit-mobile-items');

            this
                .build()
                .bind()
            ;
        }
        /* Layout */
        get viewer()            { return this._viewer || (this._viewer = this.$.find('.mm-slider-viewer').first()) }
        get itemsContainer()    { return this._itemsContainer || (this._itemsContainer = this.viewer.find('> *').first()) }
        get scrollTarget()      { return this.scrollSnap ? this.itemsContainer : this.viewer; }

        /* Getters */
        get activeItem()    { return this.viewer.find('.js-mm-slider-item.active').first() }
        get items()         { return this.viewer.find('.js-mm-slider-item') }
        get autocenter()    { return this.container.classList.contains('js-slider-aim') };
        get maxScreen()     { return App.Interface.Breakpoint.getWidth(this.container.dataset.maxScreen) }
        get width()         { return this.viewer.width() }
        get singleColum()   { return this.itemsContainer.data('column') === 1 }
        get allItemsWidth() {
            let width = 0;
            this.items.each(function() { width += this.clientWidth; });
            return width;
        }

        addItem(content, active = false, position = 'append') {
            let length = this.items.length;
            let item = App.Template.parse('component-slider-item', content, 'element');
            item.classList.add('item-' + length);
            if (active) {
                this.items.removeClass('active');
                this.active = length;
            }
            if (length === this.active)
                item.classList.add('active');
            position === 'append' ? this.itemsContainer.append(item) : this.itemsContainer.prepend(item);
            this.update();
            return this;
        }

        removeItem(indexOrSelector) {
            if (typeof index === 'number') {
                this.$.find('item-' + indexOrSelector).remove();
            } else {
                this.$.find(indexOrSelector).parents('.slider-item').remove();
            }
        }

        setItemsMaxWidth() {
            // Reduce items width to prevent huge items
            if (this.maxScreen && this.maxScreen > $(window).width() && !this.container.classList.contains('has-arrows')) {

                let width = (this.width * this.covering) - 30; // 30 represents the $grid-gutter-width in scss;
                if (this.singleColum) {
                    width = this.width;
                }
                this.viewer.find('.js-mm-slider-item > *').css('max-width', width);

                // Reduce items width to fit one item into viewer
            } else if (this.container.classList.contains('has-arrows') && this.fitMobileItems) {

                const width = (this.width * 1) - 30; // 30 represents the $grid-gutter-width in scss
                this.viewer.find('.js-mm-slider-item > *').css('max-width', width);

                // Delete max with from inline code
            } else {
                this.viewer.find('.js-mm-slider-item > *').css('max-width', '');
            }
            this.scrollTarget.closest('.component').css('--mobile-items-height', `${this.viewer.find('.js-mm-slider-item:first-child picture:last-child img').height()}px`);
            return this;
        }

        centerItem(item, force) {
            if (this.autocenter || force) {
                var index = item.index();
                var itemPos = item.position().left + this.getScrollValue() + (item.outerWidth() / 2);
                var scroll = itemPos - (this.viewer.outerWidth() / 2);

                /* If we at the beginning, the focus should go to the first element */
                if (!force) {
                    if (this.allowFixation && scroll < 0 || this.getScrollValue() === 0) {
                        scroll = 0;
                        if (window.userIsTouching) {
                            item = this.viewer.find('.js-mm-slider-item:first-child');
                        }
                    }

                    /* If we are at the end, the focus should go to the last element */
                    if (this.allowFixation && this.getScrollValue() >= this.viewer.find('> *:only-child').outerWidth() - $(window).width()) {
                        scroll = this.getScrollValue();
                        if (window.userIsTouching) {
                            item    = this.viewer.find('.js-mm-slider-item:last-child');
                            index   = item.index();
                        }
                    }
                }

                // scroll to the right item
                this.scrollTarget.css('scroll-snap-type', 'none');

                this.scrollTarget.stop().animate(
                    { scrollLeft: scroll },
                    this.scrollingSpeed,
                    () => this.scrollTarget.css('scroll-snap-type', 'x mandatory')
                );

                this.setActiveItem(item);

                /* Arrows */
                if (this.fitMobileItems) {
                    this.updateArrowsByIndex(index);
                }
            }
        }

        setActiveItem(item) {
            this.items.removeClass('active');
            item.addClass('active');
        }

        allowDeviation(deviation = true) {
            this.allowTouchDeviation = deviation;
        }

        updateArrowsByIndex(index) {
            this.Pagination.setBackwardVisibility(index > 0);
            this.Pagination.setForwardVisibility(index < this.items.length);
        }

        getScrollValue() {
            return this.scrollTarget.scrollLeft();
        }

        bind() {
            let self = this;
            this.scrollTarget
                .on('touchstart', function() {
                    window.userIsTouching = true;
                    self.position = self.getScrollValue();
                    clearTimeout(self.touchendTimeout);
                    clearTimeout(self.scrollTimeout);
                    clearInterval(self.playerTimer);
                    if (self.Bullets) self.Bullets.update();
                })
                .on('touchend', function() {
                    if (window.userIsTouching === true) {
                        self.touchendTimeout = setTimeout(function () {
                            self.centerItem();
                            window.userIsTouching = false;
                        }, this.centeringTransitionSpeed);
                    }
                    if (self.Bullets) self.Bullets.update();
                    self.restartAutoPlayer();
                })
                .scroll(function() {
                    self.Observer.notify();
                    clearTimeout(self.scrollTimeout);
                    if (!window.userIsTouching) {
                        self.allowFixation = true;
                        self.scrollTimeout = setTimeout(function () {
                            self.Observer.notify();
                        }, 250);
                    }
                    self.refreshLazyLoading(this);
                })
                .on('scrollstart', function() {
                    clearTimeout(self.scrollTimeout);
                    clearInterval(self.playerTimer);
                })
                .on('scrollend', function() {
                    clearTimeout(self.scrollTimeout);
                    clearInterval(self.playerTimer);
                    if (self.Bullets) self.Bullets.update();
                    self.restartAutoPlayer();
                })
            ;
            return this;
        }

        refreshLazyLoading(container) {
            var mutationObserver = new MutationObserver((mutations, me) => {
                mutations.forEach(mutation => {
                    mutation.addedNodes.forEach(node => {
                        if (node.tagName === 'IMG' && node.dataset.src) {
                            App.Interface.Images.update();
                        }
                    });
                });
            });
            mutationObserver.observe(
                container,
                {
                    childList: true,
                    subtree: true
                }
            );
        }

        scrollTo(item, direction) {
            if (item.length && this.items.outerWidth() > this.width / 3) {
                this.centerItem(item, true);
            } else {
                // Scroll in the given direction (±1) by half the container's width.
                const scroll = this.getScrollValue() + direction * this.width / 2;
                this.scrollTarget.animate({
                    // Or less if it surpasses one of the ends
                    scrollLeft: (direction === 1)
                        ? Math.min(scroll, this.scrollTarget[0].scrollWidth - this.width)
                        : Math.max(0, scroll)
                }, 200);
            }
            this.refreshLazyLoading(this.scrollTarget[0]);
        }

        build() {
            $(window).resize(() => this.update());
            this.update();
            return this;
        }

        center() {
            // Scroll to active item
            if (this.activeItem.length) {
                this.centerItem(this.activeItem, true);
            }
        }

        setAutoPlay() {
            if (this.autoPlay) {
                this.setActiveItem($(this.items[0]));

                if (this.activeItem.length) {
                    this.restartAutoPlayer();
                }
            }
        }

        restartAutoPlayer() {
            clearInterval(this.playerTimer);
            let Self    = this;
            this.playerTimer = setInterval(function() {
                if (Self.activeItem.next().length) {
                    Self.scrollTo(Self.activeItem.next(), 1);
                } else {
                    Self.setActiveItem($(Self.items[0]));
                    Self.scrollTo(Self.activeItem, -1);
                }
            }, 5000);
        }

        reset() {
            this.itemsContainer.html('');
        }

        update() {
            super.update(() => {
                this.setItemsMaxWidth();
                this.setAutoPlay();
                this.Observer.notify();
                this.center();
            });
        }
    }
    App.Components.register(App.Components.selector('slider'), Slider, 'Slider');
})();
